import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListDetails = (query) => http.get(`${api}/compras-catalogo/list-details`, { params: { ...query } })

export {
  getListDetails
}
